/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendEnumDto } from '../models/backend-enum-dto';
import { BackendGetProjectDto } from '../models/backend-get-project-dto';
import { BackendIndustryDto } from '../models/backend-industry-dto';
import { BackendPaginatedGetProjectListDto } from '../models/backend-paginated-get-project-list-dto';
import { projectsExchangeIndustriesList } from '../fn/projects-exchange/projects-exchange-industries-list';
import { ProjectsExchangeIndustriesList$Params } from '../fn/projects-exchange/projects-exchange-industries-list';
import { projectsExchangeProjectFilterEnumsRetrieve } from '../fn/projects-exchange/projects-exchange-project-filter-enums-retrieve';
import { ProjectsExchangeProjectFilterEnumsRetrieve$Params } from '../fn/projects-exchange/projects-exchange-project-filter-enums-retrieve';
import { projectsExchangeProjectsRequestContactsCreate } from '../fn/projects-exchange/projects-exchange-projects-request-contacts-create';
import { ProjectsExchangeProjectsRequestContactsCreate$Params } from '../fn/projects-exchange/projects-exchange-projects-request-contacts-create';
import { projectsExchangePublickProjectsList } from '../fn/projects-exchange/projects-exchange-publick-projects-list';
import { ProjectsExchangePublickProjectsList$Params } from '../fn/projects-exchange/projects-exchange-publick-projects-list';
import { projectsInvestorSubscribedProjectsList } from '../fn/projects-exchange/projects-investor-subscribed-projects-list';
import { ProjectsInvestorSubscribedProjectsList$Params } from '../fn/projects-exchange/projects-investor-subscribed-projects-list';
import { projectsSubscribeToProject } from '../fn/projects-exchange/projects-subscribe-to-project';
import { projectsSubscribeToProject$FormData } from '../fn/projects-exchange/projects-subscribe-to-project-form-data';
import { ProjectsSubscribeToProject$FormData$Params } from '../fn/projects-exchange/projects-subscribe-to-project-form-data';
import { ProjectsSubscribeToProject$Params } from '../fn/projects-exchange/projects-subscribe-to-project';
import { projectsSubscribeToProject$XWwwFormUrlencoded } from '../fn/projects-exchange/projects-subscribe-to-project-x-www-form-urlencoded';
import { ProjectsSubscribeToProject$XWwwFormUrlencoded$Params } from '../fn/projects-exchange/projects-subscribe-to-project-x-www-form-urlencoded';
import { projectsUnsubscribeFromProject } from '../fn/projects-exchange/projects-unsubscribe-from-project';
import { ProjectsUnsubscribeFromProject$Params } from '../fn/projects-exchange/projects-unsubscribe-from-project';

@Injectable({ providedIn: 'root' })
export class BackendApiProjectsExchangeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectsExchangeIndustriesList()` */
  static readonly ProjectsExchangeIndustriesListPath = '/api/projects/exchange/industries/';

  /**
   * Индустрии проекта.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsExchangeIndustriesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsExchangeIndustriesList$Response(
    params?: ProjectsExchangeIndustriesList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendIndustryDto>>> {
    return projectsExchangeIndustriesList(this.http, this.rootUrl, params, context);
  }

  /**
   * Индустрии проекта.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsExchangeIndustriesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsExchangeIndustriesList(
    params?: ProjectsExchangeIndustriesList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendIndustryDto>> {
    return this.projectsExchangeIndustriesList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendIndustryDto>>): Array<BackendIndustryDto> => r.body),
    );
  }

  /** Path part for operation `projectsExchangeProjectFilterEnumsRetrieve()` */
  static readonly ProjectsExchangeProjectFilterEnumsRetrievePath = '/api/projects/exchange/project-filter-enums/';

  /**
   * Получение возможных значений энумов для фильтрации.
   *
   * Получение возможных значений энумов для фильтрации.
   *
   * Returns:
   *     Response: Словарь с возможными значениями для каждого фильтра.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsExchangeProjectFilterEnumsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsExchangeProjectFilterEnumsRetrieve$Response(
    params?: ProjectsExchangeProjectFilterEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendEnumDto>> {
    return projectsExchangeProjectFilterEnumsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Получение возможных значений энумов для фильтрации.
   *
   * Получение возможных значений энумов для фильтрации.
   *
   * Returns:
   *     Response: Словарь с возможными значениями для каждого фильтра.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsExchangeProjectFilterEnumsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsExchangeProjectFilterEnumsRetrieve(
    params?: ProjectsExchangeProjectFilterEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendEnumDto> {
    return this.projectsExchangeProjectFilterEnumsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendEnumDto>): BackendEnumDto => r.body),
    );
  }

  /** Path part for operation `projectsSubscribeToProject()` */
  static readonly ProjectsSubscribeToProjectPath = '/api/projects/exchange/project-subscriptions/{id}/';

  /**
   * Подписаться на проект.
   *
   * Подписать аутентифицированного пользователя на указанный проект.
   *
   * Args:
   *     request (HttpRequest): Объект HTTP-запроса.
   *     pk (int): Основной ключ проекта, на который подписаться.
   *
   * Returns:
   *     Response: HTTP-ответ, указывающий на успешную подписку.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsSubscribeToProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsSubscribeToProject$Response(
    params: ProjectsSubscribeToProject$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendGetProjectDto>> {
    return projectsSubscribeToProject(this.http, this.rootUrl, params, context);
  }

  /**
   * Подписаться на проект.
   *
   * Подписать аутентифицированного пользователя на указанный проект.
   *
   * Args:
   *     request (HttpRequest): Объект HTTP-запроса.
   *     pk (int): Основной ключ проекта, на который подписаться.
   *
   * Returns:
   *     Response: HTTP-ответ, указывающий на успешную подписку.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsSubscribeToProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsSubscribeToProject(
    params: ProjectsSubscribeToProject$Params,
    context?: HttpContext,
  ): Observable<BackendGetProjectDto> {
    return this.projectsSubscribeToProject$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendGetProjectDto>): BackendGetProjectDto => r.body),
    );
  }

  /**
   * Подписаться на проект.
   *
   * Подписать аутентифицированного пользователя на указанный проект.
   *
   * Args:
   *     request (HttpRequest): Объект HTTP-запроса.
   *     pk (int): Основной ключ проекта, на который подписаться.
   *
   * Returns:
   *     Response: HTTP-ответ, указывающий на успешную подписку.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsSubscribeToProject$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsSubscribeToProject$XWwwFormUrlencoded$Response(
    params: ProjectsSubscribeToProject$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendGetProjectDto>> {
    return projectsSubscribeToProject$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Подписаться на проект.
   *
   * Подписать аутентифицированного пользователя на указанный проект.
   *
   * Args:
   *     request (HttpRequest): Объект HTTP-запроса.
   *     pk (int): Основной ключ проекта, на который подписаться.
   *
   * Returns:
   *     Response: HTTP-ответ, указывающий на успешную подписку.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsSubscribeToProject$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsSubscribeToProject$XWwwFormUrlencoded(
    params: ProjectsSubscribeToProject$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendGetProjectDto> {
    return this.projectsSubscribeToProject$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendGetProjectDto>): BackendGetProjectDto => r.body),
    );
  }

  /**
   * Подписаться на проект.
   *
   * Подписать аутентифицированного пользователя на указанный проект.
   *
   * Args:
   *     request (HttpRequest): Объект HTTP-запроса.
   *     pk (int): Основной ключ проекта, на который подписаться.
   *
   * Returns:
   *     Response: HTTP-ответ, указывающий на успешную подписку.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsSubscribeToProject$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsSubscribeToProject$FormData$Response(
    params: ProjectsSubscribeToProject$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendGetProjectDto>> {
    return projectsSubscribeToProject$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Подписаться на проект.
   *
   * Подписать аутентифицированного пользователя на указанный проект.
   *
   * Args:
   *     request (HttpRequest): Объект HTTP-запроса.
   *     pk (int): Основной ключ проекта, на который подписаться.
   *
   * Returns:
   *     Response: HTTP-ответ, указывающий на успешную подписку.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsSubscribeToProject$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsSubscribeToProject$FormData(
    params: ProjectsSubscribeToProject$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendGetProjectDto> {
    return this.projectsSubscribeToProject$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendGetProjectDto>): BackendGetProjectDto => r.body),
    );
  }

  /** Path part for operation `projectsUnsubscribeFromProject()` */
  static readonly ProjectsUnsubscribeFromProjectPath = '/api/projects/exchange/project-subscriptions/{id}/';

  /**
   * Отписаться от проекта.
   *
   * Отписать аутентифицированного пользователя от указанного проекта.
   *
   * Args:
   *     request (HttpRequest): Объект HTTP-запроса.
   *     pk (int): Основной ключ проекта, от которого отписаться.
   *
   * Returns:
   *     Response: HTTP-ответ, указывающий на успешную отписку.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsUnsubscribeFromProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsUnsubscribeFromProject$Response(
    params: ProjectsUnsubscribeFromProject$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectsUnsubscribeFromProject(this.http, this.rootUrl, params, context);
  }

  /**
   * Отписаться от проекта.
   *
   * Отписать аутентифицированного пользователя от указанного проекта.
   *
   * Args:
   *     request (HttpRequest): Объект HTTP-запроса.
   *     pk (int): Основной ключ проекта, от которого отписаться.
   *
   * Returns:
   *     Response: HTTP-ответ, указывающий на успешную отписку.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsUnsubscribeFromProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsUnsubscribeFromProject(
    params: ProjectsUnsubscribeFromProject$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectsUnsubscribeFromProject$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectsExchangeProjectsRequestContactsCreate()` */
  static readonly ProjectsExchangeProjectsRequestContactsCreatePath =
    '/api/projects/exchange/projects/request-contacts/{id}/';

  /**
   * Запросить контакты стартаппера по проекту.
   *
   * Request project contacts
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsExchangeProjectsRequestContactsCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsExchangeProjectsRequestContactsCreate$Response(
    params: ProjectsExchangeProjectsRequestContactsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectsExchangeProjectsRequestContactsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Запросить контакты стартаппера по проекту.
   *
   * Request project contacts
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsExchangeProjectsRequestContactsCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsExchangeProjectsRequestContactsCreate(
    params: ProjectsExchangeProjectsRequestContactsCreate$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectsExchangeProjectsRequestContactsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectsExchangePublickProjectsList()` */
  static readonly ProjectsExchangePublickProjectsListPath = '/api/projects/exchange/publick_projects/';

  /**
   * Получить публичные проекты.
   *
   * Список и создание проектов.
   *
   * При создании проекта учитывается ограничение на создание проектов согласно тарифу пользователя.
   * В теле запроса для создания проекта можно добавить данные по конфигу проекта. Если такие данные
   * не будут предоставлены, проект будет создан без конфигурации.
   *
   * При использовании метода POST документация будет основана на сериализаторе конфига.
   *
   * Енумы для конфигов берутся из эндпоинта "api_projects_enum_choices_retrieve".
   *
   * Источники финансирования берутся из эндпоинта "api_projects_financing_sources_list".
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsExchangePublickProjectsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsExchangePublickProjectsList$Response(
    params?: ProjectsExchangePublickProjectsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPaginatedGetProjectListDto>> {
    return projectsExchangePublickProjectsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Получить публичные проекты.
   *
   * Список и создание проектов.
   *
   * При создании проекта учитывается ограничение на создание проектов согласно тарифу пользователя.
   * В теле запроса для создания проекта можно добавить данные по конфигу проекта. Если такие данные
   * не будут предоставлены, проект будет создан без конфигурации.
   *
   * При использовании метода POST документация будет основана на сериализаторе конфига.
   *
   * Енумы для конфигов берутся из эндпоинта "api_projects_enum_choices_retrieve".
   *
   * Источники финансирования берутся из эндпоинта "api_projects_financing_sources_list".
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsExchangePublickProjectsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsExchangePublickProjectsList(
    params?: ProjectsExchangePublickProjectsList$Params,
    context?: HttpContext,
  ): Observable<BackendPaginatedGetProjectListDto> {
    return this.projectsExchangePublickProjectsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendPaginatedGetProjectListDto>): BackendPaginatedGetProjectListDto => r.body),
    );
  }

  /** Path part for operation `projectsInvestorSubscribedProjectsList()` */
  static readonly ProjectsInvestorSubscribedProjectsListPath = '/api/projects/exchange/subscribed-projects/';

  /**
   * Получить проекты, на которые подписан текущий инвестор.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsInvestorSubscribedProjectsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsInvestorSubscribedProjectsList$Response(
    params?: ProjectsInvestorSubscribedProjectsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPaginatedGetProjectListDto>> {
    return projectsInvestorSubscribedProjectsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Получить проекты, на которые подписан текущий инвестор.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsInvestorSubscribedProjectsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsInvestorSubscribedProjectsList(
    params?: ProjectsInvestorSubscribedProjectsList$Params,
    context?: HttpContext,
  ): Observable<BackendPaginatedGetProjectListDto> {
    return this.projectsInvestorSubscribedProjectsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendPaginatedGetProjectListDto>): BackendPaginatedGetProjectListDto => r.body),
    );
  }
}
